import moment from 'moment';
import Request from './../../request';
import { IDepositTransactionResourceProps, IDepositTransactionResourceShortProps } from '../../../props/finance/incomes/deposits/transactions';
import { IPaginationResourceShort } from '../../../props/general';

// import props

const DepositTransactionService = {
    retrieve: async (qs?: string): Promise<{pagination: IPaginationResourceShort, data: IDepositTransactionResourceShortProps[]}> => {
        try {
            const result = await Request.get(`/api/deposits/transactions?${qs}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    create: async (data: FormData): Promise<IDepositTransactionResourceProps> => {
        try {
            const result = await Request.post(`/api/deposits/transactions`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    },
    read: async (id: string): Promise<IDepositTransactionResourceShortProps> => {
        try {
            const result = await Request.get(`/api/deposits/transactions/${id}`);
            return result;
        } catch (e) {
            throw (e);
        }
    }
}

export default DepositTransactionService;